// src/components/kuestion/shared/AppNoticeboard.jsx
//
// The noticeboard as the Kuestion app mounts it (Noticeboard contract §6.1):
// the `kuestion` feed, the app's own acknowledgement key, 34px beside its
// neighbours, the effective zone and clock from the account's preferences,
// and a reread when the tab comes back after ten minutes.
//
// Auto-open waits for the first-login tour or a section intro, so the two
// never stack (§6.4): held until we know whether a tour is starting, released
// when it closes. The badge shows in the meantime.
//
// NEVER mount this in a sitting. Nothing interrupts a candidate.
import React, { useEffect, useState } from 'react';
import Noticeboard from '../../noticeboard/Noticeboard';
import { useTour } from './Tour';
import { usePreferences } from './PreferencesContext';

export default function AppNoticeboard({ store = 'kq', size = 34 }) {
  const tour = useTour();
  const prefs = usePreferences();
  // The tour offers itself in an effect of a provider above us, which runs
  // after ours. Waiting one commit means `tour.active` is already true by the
  // time auto-open is released.
  const [ready, setReady] = useState(false);
  useEffect(() => { setReady(true); }, []);

  return (
    <Noticeboard
      surface="kuestion"
      store={store}
      size={size}
      autoOpen={ready && !(tour && tour.active)}
      zone={prefs ? prefs.zone : undefined}
      clock={prefs ? prefs.prefs.clock : undefined}
      refetchOnFocus
    />
  );
}
